'server only'

import { createClient as createSupabaseClient } from '@supabase/supabase-js'

export const createAdminClient = async ({ schema }: { schema?: string } = {}) => {
    const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!
    const serviceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY!
    
    return createSupabaseClient(supabaseUrl, serviceRoleKey, {
        auth: {
            persistSession: false,
            autoRefreshToken: false,
            detectSessionInUrl: false
        },
        db: schema ? { schema } : undefined
    })
}



